/**
 * Gate for bulk chain-of-title document download: checking 1+ rows in the documents table
 * and downloading just those via "Download Selected" ("Get Selected Documents" is disabled
 * with nothing checked). When off, each row keeps its individual per-document download only.
 */
import { useFeatureFlagEnabled } from '@posthog/react';

export const BULK_DOCUMENT_DOWNLOAD_FLAG = 'land-rights-enable-bulk-document-download';

export function useBulkDocumentDownloadEnabled(): boolean {
  return useFeatureFlagEnabled(BULK_DOCUMENT_DOWNLOAD_FLAG) === true;
}
